import {ModalProps} from "../../modal";
import {useEffect, useState} from "react";
import {getItem} from "../../../utils/communication";

export default function IngredientsModal(ingredients: Ingredient[], setIngredients: (ingredients: Ingredient[]) => void, allIngredients: Ingredient[]) {
    const handleIngredientChange = (ingredient: Ingredient) => {
        let newIngredients = [...ingredients];
        let index = newIngredients.findIndex(i => i.publicId === ingredient.publicId);

        if (index === -1) {
            newIngredients.push(ingredient);
        } else {
            newIngredients.splice(index, 1);
        }

        setIngredients(newIngredients);
    }

    return (
        <div className="grid grid-cols-3 gap-4">
            {allIngredients.map((allIngredient, index) => (
                <div key={index} className="ingredient">
                    <input checked={hasIngredient(allIngredient, ingredients)}
                           onChange={() => handleIngredientChange(allIngredient)}
                           type="checkbox" id={allIngredient.publicId}/>
                    <label htmlFor={allIngredient.publicId}>{allIngredient.name}</label>
                </div>
            ))}
        </div>
    );
}

function hasIngredient(ingredient: Ingredient, ingredients: Ingredient[]): boolean {
    return ingredients.some(i => i.publicId === ingredient.publicId);
}